define.alias("shared/components/shared/schedule-navbar/notification", "media/components/shared/schedule-navbar/notification");